import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  title1ahgushtajx2d as title,
  title1nssp3ryhwuqj as title_0,
} from '../../../theming/Titles.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../theming/sections.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../keyValue.mjs';
import { PhoneNumberFormat_USA_getInstance22618h2la6wkm as PhoneNumberFormat_USA_getInstance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  get_atBottomEnd1uhyy6gazj2pk as get_atBottomEnd,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  MessageButton_getInstance33lwpvjn45jp0 as MessageButton_getInstance,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../screens/common/ProjectView.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration__plus_impl_yu9v8f2gb5hwgakp0dd as Duration__plus_impl_yu9v8f,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { debounce302w6e33401uo as debounce } from '../../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { expandIcon1as9er6lyg7in as expandIcon } from '../../expansion.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../nav/crowpay.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Dialog1vemwbargnizv as Dialog } from '../activity/messages.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toggle2o6h9frvgo8sq as toggle } from '../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function contractorInformation(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  title(view, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj(_this__u8e3s4.hgl()).b5j_1.toString() + ' Information';
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  var tmp = get_lightSection(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  keyString(view_1, 'Name', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.hgl()).v5i_1);
  keyString(view_1, 'Address', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.hgl()).z5i_1.toString());
  keyString(view_1, 'Email', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.hgl()).x5i_1);
  keyString(view_1, 'Phone', ($this$keyString) => {
    var tmp = PhoneNumberFormat_USA_getInstance();
    // Inline function 'kotlin.text.filter' call
    var tmp0 = $this$keyString.daj(_this__u8e3s4.hgl()).y5i_1;
    // Inline function 'kotlin.text.filterTo' call
    var destination = StringBuilder().d1();
    var inductionVariable = 0;
    var last = charSequenceLength(tmp0);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = charSequenceGet(tmp0, index);
        if (isDigit(element)) {
          destination.xb(element);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$4 = destination.toString();
    return tmp.adb(tmp$ret$4);
  });
  view_0.hbb(p_1, view_1);
  var tmp_0 = view_0.kbb(get_atBottomEnd(view_0), view_0.jbb(MessageButton_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  specCenteredText(view_2, 'Message');
  onClick(view_2, VOID, VOID, contractorInformation$slambda_0(_this__u8e3s4));
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp_0, view_2);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  writer.hbb(p, view);
  return view;
}
function projectInformation(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  var $this$col = view;
  var opened = Signal().hak(_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance()));
  var tmp = $this$col.mba().vb0_1;
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
  var openedDebounced = debounce(opened, Duration__plus_impl_yu9v8f(tmp, tmp$ret$0));
  reactive($this$col, ($this$reactive) => {
    var tmp;
    if ($this$reactive.daj(openedDebounced)) {
      $this$col.pb9(null, null, true);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())($this$col.pc());
  var tmp0_elvis_lhs_0 = $this$col.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
  $this$col.gbb(p_0, view_0);
  view_0.gba(get_rem(0));
  view_0.bb9(get_rem(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_rem(0));
  title_0(view_1, 'Project Information');
  var tmp_0 = get_expanding(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_0, view_2);
  view_1.lbb(get_centered(view_1), expandIcon(view_1, opened));
  view_0.hbb(p_1, view_1);
  onClick(view_0, VOID, VOID, projectInformation$slambda_0(opened));
  $this$col.hbb(p_0, view_0);
  var tmp_1 = $this$col.kbb($this$col.kbb(shownWhen($this$col, VOID, ($this$shownWhen) => $this$shownWhen.daj(opened)), sizeConstraints($this$col, VOID, VOID, get_rem(11))), get_lightSection($this$col));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_3 = $this$col.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? $this$col : tmp0_elvis_lhs_3;
  $this$col.gbb(p_3, view_3);
  view_3.zbm(true);
  keyString(view_3, 'Project Name', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.lfy()).b7b_1);
  keyString(view_3, 'Address', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.lfy()).d7b_1.toString());
  keyString(view_3, 'Location', ($this$keyString) => {
    var tmp0_safe_receiver = $this$keyString.daj(_this__u8e3s4.lfy()).e7b_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(tmp0_safe_receiver)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  });
  $this$col.hbb(p_3, view_3);
  $this$col.lbb(tmp_1, view_3);
  writer.hbb(p, view);
  return view;
}
function billingInformation(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  var $this$col = view;
  var opened = Signal().hak(_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance()));
  var tmp = $this$col.mba().vb0_1;
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
  var openedDebounced = debounce(opened, Duration__plus_impl_yu9v8f(tmp, tmp$ret$0));
  reactive($this$col, ($this$reactive) => {
    var tmp;
    if ($this$reactive.daj(openedDebounced)) {
      $this$col.pb9(null, null, true);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())($this$col.pc());
  var tmp0_elvis_lhs_0 = $this$col.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
  $this$col.gbb(p_0, view_0);
  view_0.gba(get_rem(0));
  view_0.bb9(get_rem(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_rem(0));
  title_0(view_1, 'Billing Information');
  var tmp_0 = get_expanding(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_0, view_2);
  view_1.lbb(get_centered(view_1), expandIcon(view_1, opened));
  view_0.hbb(p_1, view_1);
  onClick(view_0, VOID, VOID, billingInformation$slambda_0(opened));
  $this$col.hbb(p_0, view_0);
  var tmp_1 = $this$col.kbb($this$col.kbb(shownWhen($this$col, VOID, ($this$shownWhen) => $this$shownWhen.daj(opened)), sizeConstraints($this$col, VOID, VOID, get_rem(11))), get_lightSection($this$col));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_3 = $this$col.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? $this$col : tmp0_elvis_lhs_3;
  $this$col.gbb(p_3, view_3);
  view_3.zbm(true);
  keyString(view_3, 'Client Name', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.ygk()).d5c_1);
  var tmp_2 = shownWhen(view_3, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.let' call
    var it = $this$shownWhen.daj(_this__u8e3s4.ygk());
    return !(it.d5c_1 === it.p92());
  });
  view_3.lbb(tmp_2, keyString(view_3, 'Contact Name', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.ygk()).p92()));
  keyString(view_3, 'Address', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.ygk()).i5c_1.toString());
  keyString(view_3, 'Email', ($this$keyString) => $this$keyString.daj(_this__u8e3s4.ygk()).g5c_1);
  keyString(view_3, 'Phone', ($this$keyString) => {
    var tmp = PhoneNumberFormat_USA_getInstance();
    // Inline function 'kotlin.text.filter' call
    var tmp0 = $this$keyString.daj(_this__u8e3s4.ygk()).h5c_1;
    // Inline function 'kotlin.text.filterTo' call
    var destination = StringBuilder().d1();
    var inductionVariable = 0;
    var last = charSequenceLength(tmp0);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = charSequenceGet(tmp0, index);
        if (isDigit(element)) {
          destination.xb(element);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$15 = destination.toString();
    return tmp.adb(takeLast(tmp$ret$15, 10));
  });
  $this$col.hbb(p_3, view_3);
  $this$col.lbb(tmp_1, view_3);
  writer.hbb(p, view);
  return view;
}
function contacts(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(true);
  if (!_this__u8e3s4.tgj().equals(ProjectLens_Contractor_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().ig2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.lbb(get_expanding(view_0), contractorInformation(_this__u8e3s4, view_0));
    var tmp = get_expanding(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Space())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp, view_1);
    view.hbb(p_0, view_0);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint_0 = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint_0)));
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.lbb(get_expanding(view_2), projectInformation(_this__u8e3s4, view_2));
  view_2.lbb(get_expanding(view_2), billingInformation(_this__u8e3s4, view_2));
  view.hbb(p_2, view_2);
  writer.hbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = $this.wgz_1.tgj();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.wgz_1.lfy();
  var tmp_1 = await_0(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$0 = tmp_1;
  tmp.zgd(new (Dialog())(tmp_0, tmp$ret$0));
  return Unit_instance;
}
var contractorInformation$slambdaClass;
function contractorInformation$slambda() {
  if (contractorInformation$slambdaClass === VOID) {
    class $ {
      constructor($this_contractorInformation) {
        this.wgz_1 = $this_contractorInformation;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    contractorInformation$slambdaClass = $;
  }
  return contractorInformation$slambdaClass;
}
function contractorInformation$slambda_0($this_contractorInformation) {
  var i = new (contractorInformation$slambda())($this_contractorInformation);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var projectInformation$slambdaClass;
function projectInformation$slambda() {
  if (projectInformation$slambdaClass === VOID) {
    class $ {
      constructor($opened) {
        this.xgz_1 = $opened;
      }
      uao($completion) {
        toggle(this.xgz_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectInformation$slambdaClass = $;
  }
  return projectInformation$slambdaClass;
}
function projectInformation$slambda_0($opened) {
  var i = new (projectInformation$slambda())($opened);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ygz_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.ygz_1.iah(!tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var billingInformation$slambdaClass;
function billingInformation$slambda() {
  if (billingInformation$slambdaClass === VOID) {
    class $ {
      constructor($opened) {
        this.ygz_1 = $opened;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    billingInformation$slambdaClass = $;
  }
  return billingInformation$slambdaClass;
}
function billingInformation$slambda_0($opened) {
  var i = new (billingInformation$slambda())($opened);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  contacts as contacts16kylqd85uusk,
};
//endregion

//# sourceMappingURL=contacts.mjs.map
